import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { calculateCompanyFundamentals } from '../../services/riskProducts.service';
import { CalculateFundamentalsDTO } from '../../services/dtos/fundamentalMetrics.dto';
import { CalculatedFundamentals } from '../../models/CalculatedFundamentals';

export default (): UseMutationResult<CalculatedFundamentals, Error, CalculateFundamentalsDTO> => {
  return useMutation(
    (data: CalculateFundamentalsDTO) => {
      return calculateCompanyFundamentals(data);
    },
    {
      onSuccess: (calculatedFundamentals) => {
        return calculatedFundamentals;
      },
    }
  );
};
